var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.58027H2.58333C2.0971 1.58027 1.63079 1.75586 1.28697 2.06842C0.943154 2.38098 0.75 2.80491 0.75 3.24693V14.9136C0.75 15.3556 0.943154 15.7796 1.28697 16.0921C1.63079 16.4047 2.0971 16.5803 2.58333 16.5803H15.4167C15.9029 16.5803 16.3692 16.4047 16.713 16.0921C17.0568 15.7796 17.25 15.3556 17.25 14.9136V9.08027M14.8437 1.26777C15.2084 0.936246 15.703 0.75 16.2187 0.75C16.7345 0.75 17.2291 0.936246 17.5937 1.26777C17.9584 1.59929 18.1633 2.04893 18.1633 2.51777C18.1633 2.98661 17.9584 3.43625 17.5937 3.76777L9.33183 11.2794C9.11417 11.4771 8.84527 11.6219 8.54992 11.7003L5.91633 12.4003C5.83746 12.4212 5.75384 12.4224 5.67425 12.4039C5.59466 12.3854 5.52201 12.3477 5.46391 12.2949C5.40581 12.2421 5.3644 12.176 5.34401 12.1037C5.32361 12.0313 5.32499 11.9553 5.348 11.8836L6.118 9.48943C6.20465 9.22114 6.36416 8.97698 6.58183 8.77943L14.8437 1.26777Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.11f18adb36e69ba07b5344379d2556f3.svg";
export { ForwardRef as ReactComponent };